import i18n from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'react-native-paper';
import { messageStyles } from './styles';
import { MessageComponent, MessageComponentProps } from './types';

export const ReminderMessage: MessageComponent = (
  props: MessageComponentProps
) => {
  const { t } = useTranslation();
  const { reminderData } = props.message;
  const { updatedBy } = props.message; // User who created the reminder
  const { name } = updatedBy;

  const firstName = name?.first || 'anonymous';
  const lastName = name?.last || '';

  if (!reminderData || reminderData === null) return;
  const { reminderType, reminderDate, intervalDays, startDate } = reminderData;

  const getFormattedDate = (date: string) => {
    const formattedDate = new Date(date).toLocaleDateString(i18n.language, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

    return formattedDate;
  };

  // Client-side date formatting with user's locale/timezone
  const formattedDate = useMemo(() => {
    if (reminderType === 'date' && reminderDate) {
      const dateLabel = getFormattedDate(reminderDate);

      return dateLabel;
    } else {
      if (reminderType !== 'interval') return 'error';

      const firstReminderDate = new Date(startDate);
      firstReminderDate.setDate(
        firstReminderDate.getDate() + Number(intervalDays)
      );

      const dateLabel = getFormattedDate(String(firstReminderDate));

      return dateLabel;
    }
  }, [reminderData]);

  return (
    <Text style={messageStyles.messageText}>
      {`${firstName} ${lastName} ${t(
        'reminders.setNewReminder'
      )} ${formattedDate}`}
    </Text>
  );
};
